import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { UserDataBaseModel } from 'franke-trough-dependencies';
import { LogoCentered } from 'src/app/Partials';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './RegisterSucceeded.messages';


import './RegisterSucceeded.page.scss';
import { Link } from 'react-router-dom';
import { formatMessage } from 'src/api';
import InfoBanner from 'src/app/Partials/InfoBanner/InfoBanner';

export interface RegisterSucceededProps {
  dispatch: any;
  registerUserState: RequestApiResult<UserDataBaseModel>;
}

export interface RegisterSucceededState {
  hasNoResult: boolean;
}

export class RegisterSucceededComponent extends React.Component<RegisterSucceededProps, RegisterSucceededState> {
  constructor(props: RegisterSucceededProps) {
    super(props);

    this.state = {
      hasNoResult: true,
    };
  }

  componentDidMount() {
    this.props.dispatch(requestAPIActions.loadCleared('registerUser'));
  }

  public render() {
    const { registerUserState } = this.props;
    return (
      <div className="page-successful d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="col-12">
            <LogoCentered withHome={false} />

            <InfoBanner label={formatMessage({...MESSAGES.registerSucceededNote})} text={formatMessage({...MESSAGES.registerSucceededNoteText})} /> 

            <h4>
              <FormattedMessage {...MESSAGES.registerSucceededHeading} />
            </h4>
            <p className="mb-4" dangerouslySetInnerHTML={{__html: formatMessage({...MESSAGES.registerSucceededText})}} />
            <Link className="btn btn-secondary w-100 d-block" to="/">
              <FormattedMessage {...MESSAGES.registerSucceededButton} />
            </Link>
          </div>
        </div>
        {registerUserState && registerUserState.loaded && registerUserState.result && (
          <></>
        )}
      </div>
    );
  }
}

interface StateProps {
  registerUser: RequestApiResult<UserDataBaseModel>;
}

export const RegisterSucceededPage = connect((state: StateProps) => ({
  registerUserState: state.registerUser,
}))(RegisterSucceededComponent);

export default RegisterSucceededPage;
